// import React, { useState, useEffect } from "react";
// import "./unitmodal.css";  // Make sure to create a corresponding CSS file for styling
// import { IoIosCloseCircleOutline } from "react-icons/io";

// function UnitModal({ show, handleClose, units, selectedUnitId, handleApply }) {
//   const [localSelectedUnitId, setLocalSelectedUnitId] = useState(selectedUnitId);

//   useEffect(() => {
//     setLocalSelectedUnitId(selectedUnitId);
//   }, [selectedUnitId]);

//   if (!show) {
//     return null;
//   }

//   const handleUnitChange = (unitId) => {
//     setLocalSelectedUnitId(unitId);
//   };

//   const handleApplyClick = () => {
//     handleApply(localSelectedUnitId);
//     handleClose();
//   };

//   return (
//     <div className="modal-unit">
//       <div className="modal-content-unit">
//         <IoIosCloseCircleOutline
//           style={{ float: "right", cursor: "pointer" }}
//           onClick={handleClose}
//           size={30}

//         />
//         <h2>Select a Unit</h2>
//         <ul>
//           {units.map((unit) => (
//             <li key={unit.entity_id}>
//               <label>
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "start",
//                     justifyContent: "space-between",
//                     gap: "5px",
//                     padding: "10px",
//                   }}
//                 >
//                   <div>
//                     <p style={{ fontSize: "15px" }}>{unit.unit_name}</p>
//                     <p style={{ fontSize: "10px" }}>{unit.address}</p>
//                   </div>
//                   <div>
//                     <input
//                       type="radio"
//                       name="unit"
//                       value={unit.entity_id}
//                       checked={localSelectedUnitId === unit.entity_id}
//                       onChange={() => handleUnitChange(unit.entity_id)}
//                     />
//                   </div>
//                 </div>
//               </label>
//             </li>
//           ))}
//         </ul>
//         <button onClick={handleApplyClick} disabled={!localSelectedUnitId}>
//           Apply
//         </button>
//       </div>
//     </div>
//   );
// }

// export default UnitModal;

// UnitModal.jsx

// import React, { useState, useEffect } from "react";
// // Reusing the tenant modal CSS for a consistent look.
// import "./unitmodal.css";
// import { IoIosCloseCircleOutline } from "react-icons/io";

// function UnitModal({
//   show,
//   handleClose,
//   units,
//   selectedUnitIds, // CHANGED: Prop now expects an array of IDs
//   handleApply,
// }) {
//   // State to manage the selection within the modal
//   const [localSelectedIds, setLocalSelectedIds] = useState(
//     selectedUnitIds || []
//   );

//   // Sync state if the modal is reopened with different external selections
//   useEffect(() => {
//     setLocalSelectedIds(selectedUnitIds || []);
//   }, [selectedUnitIds, show]);

//   if (!show) {
//     return null;
//   }

//   // Handle clicking a checkbox
//   const handleUnitChange = (unitId) => {
//     setLocalSelectedIds((prevIds) =>
//       // If the ID is already selected, filter it out. Otherwise, add it.
//       prevIds.includes(unitId)
//         ? prevIds.filter((id) => id !== unitId)
//         : [...prevIds, unitId]
//     );
//   };

//   // Pass the array of selected IDs back to the parent component
//   const handleApplyClick = () => {
//     handleApply(localSelectedIds);
//     handleClose();
//   };

//   return (
//     <div className="modal-tenant">
//       {" "}
//       {/* Reusing CSS class */}
//       <div className="modal-content-tenant">
//         <div className="modal-header flex justify-between items-center">
//           <h2>Select Units</h2>
//           <IoIosCloseCircleOutline
//             className="modal-close-icon"
//             onClick={handleClose}
//             size={30}
//           />
//         </div>

//         <ul className="tenant-list">
//           {/* Ensure units is an array before mapping */}
//           {(units || []).map((unit) => (
//             <li key={unit.entity_id}>
//               <label className="tenant-item-label">
//                 <div
//                   style={{
//                     display: "flex",
//                     alignItems: "start",
//                     justifyContent: "space-between",
//                     gap: "5px",
//                     padding: "10px",
//                   }}
//                 >
//                   <div className="tenant-info">
//                     <p style={{ fontSize: "15px" }}>{unit.unit_name}</p>
//                     <p style={{ fontSize: "10px" }}>{unit.building_name}</p>
//                   </div>
//                   <input
//                     type="checkbox" // CHANGED: from radio to checkbox
//                     className="tenant-checkbox"
//                     // Check if the unit's ID is in our local array
//                     checked={localSelectedIds.includes(unit.entity_id)}
//                     // Update the local array on change
//                     onChange={() => handleUnitChange(unit.entity_id)}
//                   />
//                 </div>
//               </label>
//             </li>
//           ))}
//         </ul>

//         <div className="modal-footer">
//           <button onClick={handleApplyClick} className="apply-button">
//             Apply ({localSelectedIds.length})
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UnitModal;

// import React, { useState, useEffect } from "react";
// import { IoIosCloseCircleOutline } from "react-icons/io";

// function UnitModal({
//   show,
//   handleClose,
//   units,
//   selectedUnitIds, // Prop expects an array of IDs
//   handleApply,
// }) {
//   const [localSelectedIds, setLocalSelectedIds] = useState([]);
//   const [searchQuery, setSearchQuery] = useState(""); // New state for search query

//   useEffect(() => {
//     if (show) {
//       setLocalSelectedIds(selectedUnitIds || []);
//       setSearchQuery(""); // Clear search query when modal opens
//     }
//   }, [show, selectedUnitIds]);

//   if (!show) {
//     return null;
//   }

//   const handleUnitChange = (unitId) => {
//     setLocalSelectedIds((prevIds) =>
//       prevIds.includes(unitId)
//         ? prevIds.filter((id) => id !== unitId)
//         : [...prevIds, unitId]
//     );
//   };

//   const handleApplyClick = () => {
//     handleApply(localSelectedIds);
//     handleClose();
//   };

//   const unitsToFilter = units || [];

//   const filteredUnits = unitsToFilter.filter((unit) => {
//     const searchLower = searchQuery.toLowerCase();
//     const unitNameLower = unit.unit_name.toLowerCase();
//     const buildingNameLower = unit.building_name.toLowerCase();

//     return (
//       unitNameLower.includes(searchLower) ||
//       buildingNameLower.includes(searchLower)
//     );
//   });

//   const handleSelectAll = () => {
//     setLocalSelectedIds(filteredUnits.map((unit) => unit.entity_id));
//   };

//   const handleClearAll = () => {
//     setLocalSelectedIds([]);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//       <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 h-[80vh] flex flex-col">
//         {/* Fixed Header */}
//         <div className="flex-shrink-0 flex items-center justify-between p-4 border-b border-gray-200">
//           <h2 className="text-lg font-semibold text-gray-800">Select Units</h2>
//           <button
//             onClick={handleClose}
//             className="text-gray-400 hover:text-gray-600 transition-colors"
//           >
//             <IoIosCloseCircleOutline size={30} />
//           </button>
//         </div>

//         {/* Search Input Field */}
//         <div className="flex-shrink-0 p-4 border-b border-gray-100">
//           <input
//             type="text"
//             placeholder="Search units by name or building..."
//             className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>

//         {/* Actions Bar (Fixed) */}
//         <div className="flex-shrink-0 flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50">
//           <span className="text-sm text-gray-600">
//             {localSelectedIds.length} of {filteredUnits.length} visible units
//             selected
//           </span>
//           <div className="flex gap-2">
//             <button
//               onClick={handleSelectAll}
//               className="text-sm text-blue-600 hover:text-blue-800 font-medium"
//             >
//               Select All
//             </button>
//             <span className="text-gray-300">|</span>
//             <button
//               onClick={handleClearAll}
//               className="text-sm text-red-600 hover:text-red-800 font-medium"
//             >
//               Clear All
//             </button>
//           </div>
//         </div>

//         {/* Scrollable Content */}
//         <div className="flex-1 overflow-y-auto p-4">
//           {filteredUnits.length > 0 ? (
//             // 🔥 CHANGED: Added grid and responsive column classes here
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
//               {filteredUnits.map((unit) => (
//                 <label
//                   key={unit.entity_id}
//                   // Adjusted padding and removed some old flex styles if not needed
//                   className="flex items-center p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors"
//                 >
//                   <input
//                     type="checkbox"
//                     className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
//                     checked={localSelectedIds.includes(unit.entity_id)}
//                     onChange={() => handleUnitChange(unit.entity_id)}
//                   />
//                   <div className="ml-3 flex-1">
//                     <div className="font-medium text-gray-900">
//                       {unit.unit_name}
//                     </div>
//                     <div className="text-sm text-gray-500">
//                       {unit.building_name}
//                     </div>
//                     {unit.occupancy_status && (
//                       <div className="text-xs mt-1">
//                         <span
//                           className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
//                             unit.occupancy_status === "rented"
//                               ? "bg-green-100 text-green-800"
//                               : "bg-gray-100 text-gray-800"
//                           }`}
//                         >
//                           {unit.occupancy_status}
//                         </span>
//                       </div>
//                     )}
//                   </div>
//                   {localSelectedIds.includes(unit.entity_id) && (
//                     <div className="ml-2 text-blue-600">
//                       <svg
//                         className="w-5 h-5"
//                         fill="currentColor"
//                         viewBox="0 0 20 20"
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                     </div>
//                   )}
//                 </label>
//               ))}
//             </div>
//           ) : (
//             <div className="flex flex-col items-center justify-center py-12 text-gray-500">
//               <svg
//                 className="w-12 h-12 mb-4"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H9m0 0H5m4 0v-1.5"
//                 />
//               </svg>
//               <p className="text-sm">
//                 {searchQuery
//                   ? "No units found matching your search."
//                   : "No units available."}
//               </p>
//             </div>
//           )}
//         </div>

//         {/* Fixed Footer */}
//         <div className="flex-shrink-0 p-4 border-t border-gray-200 bg-gray-50">
//           <div className="flex gap-3">
//             <button
//               onClick={handleClose}
//               className="flex-1 px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 font-medium transition-colors"
//             >
//               Cancel
//             </button>
//             <button
//               onClick={handleApplyClick}
//               className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//               disabled={localSelectedIds.length === 0}
//             >
//               Apply ({localSelectedIds.length})
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default UnitModal;

import React, { useState, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaCheckCircle, FaDoorOpen } from "react-icons/fa"; // Added relevant icons

function UnitModal({ show, handleClose, units, selectedUnitIds, handleApply }) {
  const [localSelectedIds, setLocalSelectedIds] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (show) {
      setLocalSelectedIds(selectedUnitIds || []);
      setSearchQuery("");
    }
  }, [show, selectedUnitIds]);

  if (!show) {
    return null;
  }

  const handleUnitChange = (unitId) => {
    setLocalSelectedIds((prevIds) =>
      prevIds.includes(unitId)
        ? prevIds.filter((id) => id !== unitId)
        : [...prevIds, unitId]
    );
  };

  const handleApplyClick = () => {
    handleApply(localSelectedIds);
    handleClose();
  };

  const unitsToFilter = units || [];

  const filteredUnits = unitsToFilter.filter((unit) => {
    const searchLower = searchQuery.toLowerCase();
    const unitNameLower = (unit.unit_name || "").toLowerCase();
    const buildingNameLower = (unit.building_name || "").toLowerCase();

    return (
      unitNameLower.includes(searchLower) ||
      buildingNameLower.includes(searchLower)
    );
  });

  const handleSelectAll = () => {
    setLocalSelectedIds(filteredUnits.map((unit) => unit.entity_id));
  };

  const handleClearAll = () => {
    setLocalSelectedIds([]);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      {/* 🔥 MODAL CONTAINER: Increased width on larger screens */}
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-sm md:max-w-2xl lg:max-w-4xl max-h-[85vh] flex flex-col transition-all duration-300">
        {/* 🔥 HEADER: Increased padding and font size */}
        <div className="flex-shrink-0 flex items-center justify-between p-5 md:p-6 border-b border-gray-200">
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">
            Select Units
          </h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <IoIosCloseCircleOutline size={30} />
          </button>
        </div>

        {/* Search & Actions Bar */}
        <div className="flex-shrink-0 p-5 border-b border-gray-200 bg-gray-50 space-y-4">
          <input
            type="text"
            placeholder="Search units by name or building..."
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-base"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-600 font-medium">
              {localSelectedIds.length} selected
            </span>
            <div className="flex gap-4">
              <button
                onClick={handleSelectAll}
                className="text-sm text-blue-600 hover:underline font-semibold"
              >
                Select All Visible
              </button>
              <button
                onClick={handleClearAll}
                className="text-sm text-red-600 hover:underline font-semibold"
              >
                Clear All
              </button>
            </div>
          </div>
        </div>

        {/* 🔥 SCROLLABLE CONTENT: Increased padding and responsive grid */}
        <div className="flex-1 overflow-y-auto p-5 md:p-6">
          {filteredUnits.length > 0 ? (
            // 🔥 RESPONSIVE GRID: Uses more columns on larger screens
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {filteredUnits.map((unit) => {
                const isSelected = localSelectedIds.includes(unit.entity_id);
                return (
                  <label
                    key={unit.entity_id}
                    // 🔥 CARD STYLING: Clearer visual feedback on selection and hover
                    className={`flex items-start p-4 rounded-lg border-2 cursor-pointer transition-all duration-200
                                ${
                                  isSelected
                                    ? "bg-blue-50 border-blue-500 shadow-md"
                                    : "bg-white border-gray-200 hover:border-blue-400 hover:shadow-sm"
                                }`}
                  >
                    <input
                      type="checkbox"
                      className="w-5 h-5 mt-0.5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 shrink-0"
                      checked={isSelected}
                      onChange={() => handleUnitChange(unit.entity_id)}
                    />
                    <div className="ml-4 flex-1">
                      <div className="font-semibold text-gray-900 leading-tight">
                        {unit.unit_name}
                      </div>
                      <div className="text-sm text-gray-500 mt-1">
                        {unit.building_name}
                      </div>
                      {unit.occupancy_status && (
                        <div className="text-xs mt-2">
                          <span
                            className={`inline-flex items-center px-2.5 py-1 rounded-full font-medium capitalize ${
                              unit.occupancy_status === "rented"
                                ? "bg-green-100 text-green-800"
                                : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {unit.occupancy_status}
                          </span>
                        </div>
                      )}
                    </div>
                    {isSelected && (
                      <FaCheckCircle className="w-5 h-5 text-blue-600 shrink-0" />
                    )}
                  </label>
                );
              })}
            </div>
          ) : (
            // "No results" message styling improved
            <div className="flex flex-col items-center justify-center py-16 text-gray-500 text-center">
              <FaDoorOpen className="w-16 h-16 mb-5 text-gray-300" />
              <p className="font-semibold text-lg text-gray-600">
                {searchQuery ? "No Units Found" : "No Units Available"}
              </p>
              <p className="text-sm mt-1">
                {searchQuery
                  ? "Try adjusting your search terms."
                  : "Once you add units, they will appear here."}
              </p>
            </div>
          )}
        </div>

        {/* 🔥 FOOTER: Made buttons larger and more distinct */}
        <div className="flex-shrink-0 p-5 border-t border-gray-200 bg-gray-50">
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={handleClose}
              className="w-full sm:w-auto flex-1 px-6 py-3 text-gray-800 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 font-semibold transition-colors text-base"
            >
              Cancel
            </button>
            <button
              onClick={handleApplyClick}
              className="w-full sm:w-auto flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-semibold transition-colors disabled:opacity-60 disabled:cursor-not-allowed text-base"
            >
              Apply Selection ({localSelectedIds.length})
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnitModal;
